import { NotificationLogMonitoringPage } from "../../features/notification-logs";

export function AdminNotificationLogsPage() {
  return <NotificationLogMonitoringPage />;
}
